import { useState } from "react";
import { aboutMe } from "../Content/AboutMeContent";
import { competences } from "../Content/CompetencesContent";
import { educations } from "../Content/EducationContent";
import { experiences } from "../Content/ExperiencesContent";
import { profilePicture } from "../Content/ProfilePictureContent";
import { projects } from "../Content/ProjectsContent";

import AboutMeComponent from "./AboutMeComponent";
import CompetencesComponent from "./CompetencesComponent";
import EducationComponent from "./EducationComponent";
import ExperienceComponent from "./ExperienceComponent";
import ProfilePictureComponent from "./ProfilePictureComponent";
import ProjectsComponent from "./ProjectsComponent";
import ChangeLangButton from "./ChangeLangButton";
import { tt } from "../Content/SectionTitles";
import { TitleComponent } from "./TitleComponent";
import { TitleContent } from "../Content/TitleContent";

const ResumeComponent = () => {
  const [isDanish, setIsDanish] = useState(true);
  const currentLang = isDanish ? "da" : "en";

  return (
    <div className="cv-page">
      <header className="mb-6">
        <div className="lang-fade" key={`title-${currentLang}`}>
          <TitleComponent title={TitleContent} lang={currentLang} />
        </div>
      </header>

      <div className="cv-grid">
        <main className="cv-main">
          <div className="flex flex-col gap-6 pb-2 lg:flex-row">
            <div className="block lg:hidden">
              <ProfilePictureComponent data={profilePicture} />
            </div>

            <div className="flex-1 space-y-4">
              <ChangeLangButton isDanish={isDanish} setIsDanish={setIsDanish} />
              <div className="lang-fade" key={`about-${currentLang}`}>
                <AboutMeComponent
                  data={aboutMe}
                  lang={currentLang}
                  title={tt("aboutMe", currentLang)}
                />
              </div>
            </div>
          </div>

          <div className="space-y-6">
            <div className="lang-fade" key={`experience-${currentLang}`}>
              <ExperienceComponent
                propList={experiences}
                lang={currentLang}
                title={tt("experience", currentLang)}
              />
            </div>
            <div className="lang-fade" key={`projects-${currentLang}`}>
              <ProjectsComponent
                propList={projects}
                title={tt("projects", currentLang)}
              />
            </div>
            <div className="lang-fade" key={`education-${currentLang}`}>
              <EducationComponent
                propList={educations}
                lang={currentLang}
                title={tt("education", currentLang)}
              />
            </div>
          </div>
        </main>

        <aside className="cv-side">
          <div className="cv-sticky space-y-6">
            <div className="hidden lg:block">
              <ProfilePictureComponent data={profilePicture} />
            </div>

            <div className="lang-fade" key={`competences-${currentLang}`}>
              <CompetencesComponent
                propList={competences}
                lang={currentLang}
                title={tt("competences", currentLang)}
              />
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default ResumeComponent;
